export default __webpack_public_path__ + "static/media/instagram_image.89fc7d1a.svg";